import PaymentForm from "./payment-form";

export default PaymentForm;